import type { AIOrchestrationRow } from '../../enterpriseintegration/framework';

type Props = { routes?: AIOrchestrationRow[] };

export function AIOrchestrationPanel({ routes = [] }: Props) {
  return (
    <div className="space-y-2">
      {routes.map((r) => (
        <div key={r.capability} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="flex items-center justify-between gap-3">
            <div>
              <p className="text-sm font-medium">{r.capability}</p>
              <p className="text-xs text-slate-500">{r.model}</p>
            </div>
            <div className="text-right">
              <p className="text-xs text-slate-500">{r.requests}</p>
              {r.confidence !== '—' && (
                <p className="text-xs font-medium text-brand-600">{r.confidence} confidence</p>
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
